import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthLayoutComponent } from './shared/layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { AuthGuard } from './core/guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'permissions',
        loadChildren: () => import('./pages/permissions/permissions.module').then(m => m.PermissionsModule)
      },
      {
        path: 'sync',
        loadChildren: () => import('./pages/sync/sync.module').then(m => m.SyncModule)
      },
      {
        path: 'registrations',
        loadChildren: () => import('./pages/registrations/registrations.module').then(m => m.RegistrationsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'event',
        loadChildren: () => import('./pages/event/event.module').then(m => m.EventModule)
      },
      {
        path: 'receipt',
        loadChildren: () => import('./pages/receipt/receipt.module').then(m => m.ReceiptModule)
      },
      {
        path: 'installations',
        loadChildren: () => import('./pages/installations/installations.module').then(m => m.InstallationsModule)
      },

      {
        path: 'health-monitor',
        loadChildren: () => import('./pages/health-monitor/health-monitor.module').then(m => m.HealthMonitorModule)
      },
      {
        path: 'pallet-policie',
        loadChildren: () => import('./pages/pallet-policie/pallet-policie.module').then(m => m.PalletPolicieModule)
      },
      // {
      //   path: 'administration',
      //   loadChildren: () =>
      //     import('./pages/administration/administration.module').then((m) => m.AdministrationModule)
      // },
      // {
      //   path: 'authentication-authorization',
      //   loadChildren: () =>
      //     import('./pages/authentication-authorization/authentication-authorization.module').then((m) => m.AuthenticationAuthorizationModule)
      // },
      // {
      //   path: 'master-data',
      //   loadChildren: () =>
      //     import('./pages/master-data/master-data.module').then((m) => m.MasterDataModule)
      // },
      // {
      //   path: 'administrator-interface',
      //   loadChildren: () =>
      //     import('./pages/administrator-interface/administrator-interface.module').then((m) => m.AdministratorInterfaceModule)
      // },
      // {
      //   path: 'rti',
      //   loadChildren: () =>
      //     import('./pages/rti/rti.module').then((m) => m.RtiModule)
      // }
    ]
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], //, { enableTracing: true }
  exports: [RouterModule]
})
export class AppRoutingModule { }
